<!--
 * @Author: Admni
 * @Description: 
 * @Date: 2020-12-25 16:45:25
 * @LastEditTime: 2021-03-03 11:12:25
-->
<template>
  <div class="ci-resend">
    <div
      style="display: flex; align-items: center; justify-content: space-between"
    >
      <span
        >快捷回复
        <span style="color: #8d8d8d; font-size: 12px"
          >(上传云端，随时同步)</span
        >
      </span>
      <span
        style="font-size: 14px; color: #8d8d8d; cursor: pointer"
        @click="upToClod"
      >
        上传云端
        <i class="el-icon-upload"></i>
      </span>
    </div>
    <div class="resend-list">
      <el-tree
        :data="replyData"
        :props="defaultProps"
        @node-click="handleNodeClick"
        :render-content="renderContent"
      ></el-tree>
    </div>
    <div class="add-resend">
      <el-button
        type="info"
        circle
        icon="el-icon-plus"
        @click="replyAddGroup"
      ></el-button>
    </div>

    <el-dialog
      :title="curType === 0 ? '添加分组' : '修改分组'"
      :visible.sync="replyGroupVisib"
      width="30%"
    >
      <el-row type="flex" align="middle">
        <el-col :span="4">
          <span>分组名：</span>
        </el-col>
        <el-col :span="20">
          <el-input
            placeholder="请输入标签分组名"
            v-model="replyGroupName"
            autocomplete="off"
          ></el-input>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="replyGroupVisib = false">取 消</el-button>
        <el-button
          v-if="curType === 0"
          type="primary"
          @click="replyGroupNameAdd"
          >确 定</el-button
        >
        <el-button v-else type="primary" @click="replyChildUpdata"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      :title="curType === 0 ? '添加快捷回复' : '修改快捷回复'"
      :visible.sync="replyChildVisib"
      width="40%"
    >
      <el-row type="flex" align="middle">
        <el-col :span="4">
          <span>标签：</span>
        </el-col>
        <el-col :span="20">
          <el-input
            placeholder="请输入标签"
            v-model="replyChildLable"
            autocomplete="off"
          ></el-input>
        </el-col>
      </el-row>
      <el-row type="flex" style="margin-top: 20px" align="middle">
        <el-col :span="4">
          <span>快捷回复：</span>
        </el-col>
        <el-col :span="20">
          <el-input
            placeholder="请输入快捷回复内容"
            v-model="replyChildContent"
            autocomplete="off"
          ></el-input>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="replyChildVisib = false">取 消</el-button>
        <el-button v-if="curType === 0" type="primary" @click="replyChildAdd"
          >确 定</el-button
        >
        <el-button v-else type="primary" @click="replyChildUpdata"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { quickReply } from "../../api/chat";
export default {
  name: "reply",
  props: ["name", "msg", "hasNews"],
  data() {
    return {
      up2Index: null,
      up1Index: null,
      upLeve: 0,
      curType: 0, //0 新增， 1 修改
      curTreeData: null,
      replyChildLable: "",
      replyChildContent: "",
      replyChildVisib: false,

      replyGroupName: "",
      replyGroupVisib: false,
      replyData: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
    };
  },
  created() {
    //   localStorage.setItem('reply', )
    let _reply = JSON.parse(localStorage.getItem("quickReply"));
    if (_reply) {
      this.replyData = _reply;
    }
  },
  methods: {
    upToClod() {
      let params = {
        q_r: this.replyData,
      };
      quickReply(params)
        .then((res) => {
          this.$message({
            message: "上传成功",
            type: "success",
          });
        })
        .catch((err) => {
          this.$message.error("上传失败，请重试");
        });
    },
    replyGroupNameAdd() {
      this.replyData.push({
        label: this.replyGroupName,
        add: true,
        children: [],
      });
      localStorage.setItem("quickReply", JSON.stringify(this.replyData));

      this.$message({
        message: "新增成功",
        type: "success",
      });

      this.replyGroupName = "";
      this.replyGroupVisib = false;
    },
    replyAddGroup() {
      this.replyGroupVisib = true;
    },
    replyChildUpdata() {
      if (this.upLeve === 1) {
        this.replyData[this.up1Index].label = this.replyGroupName;
      } else if (this.upLeve === 2) {
        this.replyData[this.up1Index].children[
          this.up2Index
        ].label = this.replyChildLable;
        this.replyData[this.up1Index].children[
          this.up2Index
        ].value = this.replyChildContent;
      }

      this.$message({
        message: "修改成功",
        type: "success",
      });

      this.replyGroupVisib = false;
      this.replyChildVisib = false;

      localStorage.setItem("quickReply", JSON.stringify(this.replyData));
      this.upLeve = 0;
      this.up1Index = null;
      this.up2Index = null;
      this.replyGroupName = "";
      this.replyChildLable = "";
      this.replyChildContent = "";
      this.curType = 0;
    },
    replyChildAdd() {
      this.replyData.forEach((item) => {
        if (item.label === this.curTreeData.label) {
          item.children.push({
            label: this.replyChildLable,
            value: this.replyChildContent,
            add: true,
          });
        }
      });

      this.$message({
        message: "新增成功",
        type: "success",
      });

      localStorage.setItem("quickReply", JSON.stringify(this.replyData));

      this.replyChildLable = "";
      this.replyChildContent = "";
      this.replyChildVisib = false;
    },
    handleNodeClick(data) {},
    treeUpdate(node, data) {
      this.curType = 1;
      // 一级标签
      if (node.level === 1) {
        this.replyGroupVisib = true;
        this.replyGroupName = data.label;
        this.replyData.forEach((lev1, index) => {
          if (data.label === lev1.label) {
            this.upLeve = 1;
            this.up1Index = index;
          }
        });
      } else {
        // 二级内容
        this.replyChildLable = data.label;
        this.replyChildContent = data.value;
        this.replyChildVisib = true;
        this.replyData.forEach((lev1, ind1) => {
          if (lev1.label === node.parent.label) {
            lev1.children.forEach((lev2, ind2) => {
              if (lev2.label === data.label) {
                this.upLeve = 2;
                this.up1Index = ind1;
                this.up2Index = ind2;
              }
            });
          }
        });
      }
    },
    treeRemove(node, data) {
      if (node.level === 1) {
        // 一级标签
        this.replyData.forEach((lev1, index) => {
          if (lev1.label === data.label) {
            this.replyData.splice(index, 1);
          }
        });

        this.$message({
          message: "删除成功",
          type: "success",
        });

        localStorage.setItem("quickReply", JSON.stringify(this.replyData));
      } else {
        // 二级内容
        this.replyData.forEach((lev1, ind1) => {
          if (lev1.label === node.parent.label) {
            lev1.children.forEach((lev2, ind2) => {
              if (lev2.label === data.label) {
                this.replyData[ind1].children.splice(ind2, 1);
              }
            });
          }
        });

        this.$message({
          message: "删除成功",
          type: "success",
        });

        localStorage.setItem("quickReply", JSON.stringify(this.replyData));
      }
    },
    treeAdd(node, data) {
      this.curTreeData = data;
      this.replyChildVisib = true;
    },
    treeCopy(node, data) {
      // 一级节点不复制
      if (node.level !== 1) {
        this.$emit("getTreeValue", data.value);
      }
    },
    renderContent(h, { node, data, store }) {
      if (node.level === 1) {
        return (
          <span
            class="custom-tree-node"
            style="width:100%;display:flex;align-items: center;justify-content: space-between;"
          >
            <span
              style="width:80%;white-space: normal;height:auto;font-size:14px;"
              on-click={() => this.treeCopy(node, data)}
            >
              {node.label}
            </span>

            <span style="margin-left:20px;">
              <el-button
                size="mini"
                type="text"
                on-click={() => this.treeUpdate(node, data)}
              >
                <i class="el-icon-edit"></i>
              </el-button>
              <el-button
                size="mini"
                type="text"
                on-click={() => this.treeRemove(node, data)}
              >
                <i class="el-icon-close"></i>
              </el-button>
              <el-button
                size="mini"
                type="text"
                on-click={() => this.treeAdd(node, data)}
              >
                <i class="el-icon-plus"></i>
              </el-button>
            </span>
          </span>
        );
      } else {
        return (
          <span
            class="custom-tree-node"
            style="width:100%;display:flex;align-items: center;justify-content: space-between;"
          >
            <el-tooltip
              class="item"
              effect="dark"
              placement="top-start"
            >
            <div slot="content">{data.value}</div>
              <span
                style="width:80%;white-space: normal;height:auto;font-size:14px;"
                on-click={() => this.treeCopy(node, data)}
              >
                {node.label}
              </span>
            </el-tooltip>

            <span style="margin-left:20px;">
              <el-button
                size="mini"
                type="text"
                on-click={() => this.treeUpdate(node, data)}
              >
                <i class="el-icon-edit"></i>
              </el-button>
              <el-button
                size="mini"
                type="text"
                on-click={() => this.treeRemove(node, data)}
              >
                <i class="el-icon-close"></i>
              </el-button>
            </span>
          </span>
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ci-resend {
  padding: 0 20px 20px;
  span {
    color: #333333;
    font-size: 16px;
  }
  .resend-list {
    margin-top: 10px;
  }
  .add-resend {
    margin-top: 20px;
    color: #333333;
    font-size: 16px;
  }
}
</style>